import { Navigate, Outlet, Route, Routes } from "react-router-dom"
import { adminRoutes } from "./adminRoutes"
import { renderRoutes } from "~/utils/routes"

export type AppRoute = {
  path: string
  component: JSX.Element
}

export interface RouteConfig {
  path?: string
  component?: JSX.Element
  layout?: JSX.Element
  routes?: RouteConfig[]
}

export const AppRoutes = () => {
  const routes = [...adminRoutes]
  const redirectRoute = () => {
    return "/"
  }

  return (
    <Routes>
      <Route path="/" element={<Navigate to={redirectRoute()} />} />
      <Route path="*" element={<></>} />
      {renderRoutes(routes)}
    </Routes>
  )
}
